import { useEffect, useState } from "react";

// Emergent-managed Google SSO. Do NOT hardcode redirect URL — must be window.location.origin.
const goLogin = () => {
  const redirectUrl = window.location.origin + "/menu";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function AuthErrorModal() {
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const err = params.get("auth_error");
    if (err) {
      setMsg(err);
      params.delete("auth_error");
      const clean = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
      window.history.replaceState({}, "", clean);
    }
  }, []);

  const tryGuest = async () => {
    setBusy(true);
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/guest`, { method: "POST", credentials: "include" });
      window.location.href = "/menu";
    } catch (e) {
      console.error("Guest login failed:", e);
      setBusy(false);
    }
  };

  if (!msg) return null;

  return (
    <div
      data-testid="auth-error-modal"
      onClick={() => setMsg(null)}
      style={{
        position: "fixed", inset: 0, background: "rgba(38,34,30,0.62)",
        display: "grid", placeItems: "center", zIndex: 100, padding: 20,
        fontFamily: "'Nunito Sans', sans-serif",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        style={{
          background: "#FBEFD3", color: "#26221E",
          width: "min(460px, 100%)", borderRadius: 14, padding: 28,
          boxShadow: "0 30px 80px rgba(38,34,30,0.35)",
        }}
      >
        <p className="font-mono-c" style={{ fontSize: 11, letterSpacing: "0.16em", color: "#B3261E", margin: 0, fontWeight: 700 }}>
          EMAIL PRIBADI TIDAK BISA DIPAKAI
        </p>
        <h3
          className="font-display"
          style={{ fontFamily: "'Bitter', Georgia, serif", fontWeight: 800, fontSize: 24, margin: "8px 0 12px", lineHeight: 1.25 }}
        >
          Cookingin khusus email kantor kamu.
        </h3>
        <p style={{ fontSize: 14, lineHeight: 1.55, color: "#26221E", margin: "0 0 6px" }}>
          {msg}
        </p>
        <p style={{ fontSize: 13, lineHeight: 1.55, color: "#6E6559", margin: "0 0 22px" }}>
          Marketplace ini bersifat tertutup per gedung/kantor. Kamu bisa login ulang pakai <strong>email kerjamu</strong> (domain perusahaan), atau mampir dulu sebagai <strong>tamu</strong> untuk lihat-lihat menu di kantor demo.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <button
            data-testid="auth-error-relogin"
            onClick={goLogin}
            style={{
              width: "100%", minHeight: 52, background: "#1A17E0", color: "#fff",
              border: "none", borderRadius: 4, fontWeight: 700, fontSize: 15,
              cursor: "pointer", fontFamily: "inherit",
            }}
          >
            Login lagi pakai email kantor
          </button>
          <button
            data-testid="auth-error-guest"
            onClick={tryGuest}
            disabled={busy}
            style={{
              width: "100%", minHeight: 46, background: "transparent", color: "#26221E",
              border: "1px solid rgba(38,34,30,0.24)", borderRadius: 4, fontWeight: 700, fontSize: 14,
              cursor: busy ? "not-allowed" : "pointer", fontFamily: "inherit",
            }}
          >
            {busy ? "Menyiapkan mode tamu…" : "Coba dulu sebagai Tamu"}
          </button>
          <button
            data-testid="auth-error-close"
            onClick={() => setMsg(null)}
            style={{
              width: "100%", background: "transparent", color: "#6E6559",
              border: "none", cursor: "pointer", fontSize: 12, padding: "4px 0", fontFamily: "inherit",
            }}
          >
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
}
